import React from 'react';
import { DogManagementSection } from '@/components/DogManagementSection';

export function DogManagementSectionWrapper(props) {
  return <DogManagementSection {...props} />;
}